
export default function getFingerPrint() {
  let fingerprint = [];

  fingerprint.push({ key: "user_agent", value: navigator.userAgent });
  fingerprint.push({ key: "language", value: navigator.language });
  fingerprint.push({ key: "pixel_ratio", value: window.devicePixelRatio });
  fingerprint.push({ key: "hardware_concurrency", value: navigator.hardwareConcurrency });
  fingerprint.push({ key: "resolution", value: [screen.width, screen.height] });
  fingerprint.push({ key: "available_resolution", value: [screen.availHeight, screen.availWidth] });
  fingerprint.push({ key: "timezone_offset", value: new Date().getTimezoneOffset() });
  fingerprint.push({ key: "session_storage", value: !window.sessionStorage });
  fingerprint.push({ key: "local_storage", value: !window.localStorage });
  fingerprint.push({ key: "indexed_db", value: !window.indexedDB });
  fingerprint.push({ key: "open_database", value: !window.openDatabase });
  fingerprint.push({ key: "navigator_platform", value: navigator.platform });
  fingerprint.push({ key: "navigator_oscpu", value: navigator.oscpu });
  fingerprint.push({ key: "do_not_track", value: navigator.doNotTrack });
  fingerprint.push({ key: "touch_support", value: navigator.maxTouchPoints });
  fingerprint.push({ key: "pdf_view_enabled", value: navigator.pdfViewerEnabled });
  fingerprint.push({ key: "cookie_enabled", value: navigator.cookieEnabled });
  // console.log(fingerprint);
  var short_fingerprint = "";
  fingerprint.forEach((fp) => {
    short_fingerprint += fp.value ? fp.value.toString().toLowerCase().substring(0, 1): '';
  })
  short_fingerprint += fingerprint.length;

  return short_fingerprint;
}


// WEBPACK FOOTER //
// ./src/lib/fingerprint.js